import { render } from "./user-messages.vue?vue&type=template&id=32e6bbae"
import script from "./user-messages.vue?vue&type=script&lang=js"
export * from "./user-messages.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/nuvita.net/envoyer/releases/20250711105352/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__